export const timeToNumber = (time: string) => {
  const timeArr = time.split(":");
  if (timeArr.length === 3) {
    const [hour, minute, second] = time.split(":");
    return +hour * 3600 + +minute * 60 + +second;
  }
  if (timeArr.length === 2) {
    const [minute, second] = time.split(":");
    return +minute * 60 + +second;
  }
  return 0;
};

export const numberToTime = (number: number) => {
  let hour, minute, second;
  if (number < 60 * 60) {
    minute = Math.floor(number / 60);
    second = number % 60;
    return `${(minute + "").padStart(2, "0")}:${(second + "").padStart(
      2,
      "0"
    )}`;
  } else {
    hour = Math.floor(number / 3600);
    minute = Math.floor((number % 3600) / 60);
    second = number - hour * 3600 - minute * 60;
    return `${(hour + "").padStart(2, "0")}:${(minute + "").padStart(
      2,
      "0"
    )}:${(second + "").padStart(2, "0")}`;
  }
};

export const videoExt = ["mp4", "avi", "mov", "wmv", "rmvb"];

export const isVideo = (nameOrUrl: string) => {
  const end = nameOrUrl.indexOf("?");
  const ext: string =
    nameOrUrl
      .substring(0, end === -1 ? nameOrUrl.length : end)
      .toLocaleLowerCase()
      .split(".")
      .pop() || "";
  if (videoExt.includes(ext)) return true;
  return false;
};

// 根据 video 的url，生成图片的base64
export const getVideoBaseInfo = (
  url: string
): Promise<{
  video: HTMLVideoElement;
  width: number;
  height: number;
  duration: number;
}> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = url;
    video.preload = "atuo";
    video.crossOrigin = "anonymous";
    video.addEventListener("error", error => {
      reject(error);
    });
    video.addEventListener("loadedmetadata", () => {
      resolve({
        video,
        width: video.videoWidth,
        height: video.videoHeight,
        duration: video.duration
      });
    });
  });
};

export const getVideoPosterUrl = async (videoUrl: string) => {
  if (!videoUrl) return;
  const { video, width, height } = await getVideoBaseInfo(videoUrl);
  video.currentTime = 1;
  return new Promise((resolve, reject) => {
    video.addEventListener("canplay", () => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx?.drawImage(video, 0, 0, width, height);
      const Uint8ClampedArray = ctx?.getImageData(0, 0, width, height).data;
      if (Uint8ClampedArray?.some(item => item)) {
        // 这里不知道为什么会触发两次，一次是空白的画面，需要过滤
        const url = canvas.toDataURL("image/png");
        resolve(url);
      }
    });
  });
};

export const getCurrentUsername = () => {
  try {
    const userinfo = localStorage.getItem("userInfo") || '{}';
    const { username } = JSON.parse(userinfo);
    return username;
  } catch (error) {
    console.log("error: ", error);
  }
};
